<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div class="form-edit-page row-space">
        <div class="row row-space">
            
            <div class="form-item-char30">
                <label class="label-caption">Tipo</label>
                <select v-model="opcaoSelecionada">
                    <option v-for="opcao in lsOpcoes" :key="opcao.id" :value="opcao.id">{{ opcao.descricao }}</option>
                </select>
            </div>

            <div class="form-item-rangedata"><DateRangeSelect v-model="dateRange" /></div>
            <EquipamentoGrupoSelect :ckAddTodos="true" :disabled="!opcaoSelecionadaObj.ckgrupo" v-model:idSelecionado="idGrupo" />
            <EquipamentoSelect :ckAddTodos="true" :disabled="!opcaoSelecionadaObj.ckequip" :flagTipo="1" v-model:idSelecionado="idEquipamento" />
        </div>


        <div class="row row-space">
            <RegiaoSelect :ckAddTodos="true" :disabled="!opcaoSelecionadaObj.ckregiao" v-model:idSelecionado="idRegiao" />
            <LocalidadeSelect :ckAddTodos="true" :disabled="!opcaoSelecionadaObj.cklocal" v-model:idSelecionado="idLocalidade" />
            <ServicoSelect :ckAddTodos="true" :disabled="!opcaoSelecionadaObj.ckserv" v-model:idSelecionado="idServico" v-model:objSelecionado="objServico" />
        </div>

        <div class="row-end">
            <button type="button" class="buttom-icon--printer" @click="openReport" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { Funcoes } from '@/funcoes/utils';
import { genericReport } from '@/funcoes/api';
import { globalStore } from '@/globals';
import { Validacoes } from '@/funcoes/validacoes';
import DateRangeSelect from '@/components/DateRangeSelect.vue';
import EquipamentoGrupoSelect from '@/selects/EquipamentoGrupoSelect.vue';
import EquipamentoSelect from '@/selects/EquipamentoSelect.vue';
import LocalidadeSelect from '@/selects/LocalidadeSelect.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';
import RegiaoSelect from '@/selects/RegiaoSelect.vue';
import ServicoSelect from '@/selects/ServicoSelect.vue';

const emit = defineEmits(['close']);
const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const msgAlerta = ref(null);
const idEquipamento = ref(null);
const idGrupo = ref(null);
const idLocalidade = ref(null);
const idRegiao = ref(null);
const idServico = ref(null);
const isLoading = ref(false);
const objServico = ref(null);

const lsOpcoes = ref([
    {id: 'os_executada_anservico',  descricao: 'Analítico por Serviço',         ckequip: false, ckgrupo: false, cklocal: false, ckregiao: false, ckserv: true},
    {id: 'os_executada_equipd',     descricao: 'Detalhamento por Equipamento',  ckequip: true,  ckgrupo: true,  cklocal: false, ckregiao: true,  ckserv: true},
    {id: 'os_executada_grupo',      descricao: 'Grupo de Equipamento',          ckequip: true,  ckgrupo: true,  cklocal: true,  ckregiao: true,  ckserv: true},
    {id: 'os_executada_operador',   descricao: 'Operador',                      ckequip: false, ckgrupo: false, cklocal: false, ckregiao: false, ckserv: false},
    {id: 'os_executada_regiao',     descricao: 'Regiões',                       ckequip: true,  ckgrupo: true,  cklocal: false, ckregiao: true,  ckserv: true},
]);
const opcaoSelecionada = ref('os_executada_grupo');
const opcaoSelecionadaObj = computed(() =>
    lsOpcoes.value.find(o => o.id === opcaoSelecionada.value) || {}
);

const closeForm = () => {emit('close');}

const openReport = async() => {
    try{
        Validacoes.validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);        
        if (opcaoSelecionada.value==='os_executada_anservico') Validacoes.validarId(objServico.value, 'Necessário informar o SERVIÇO para este relatório');
        if ((opcaoSelecionada.value==='os_executada_equipd') && (!idEquipamento.value)) throw new Error('Necessário informar o EQUIPAMENTO para este relatório');
        msgAlerta.value = null;
        isLoading.value = true;

        let informacoes = `Período: ${Funcoes.formatDateFromJson(dateRange.value.startDate)} a ${Funcoes.formatDateFromJson(dateRange.value.endDate)}`;
        if (opcaoSelecionada.value==='os_executada_anservico') informacoes += `; Serviço: ${objServico.value.nmservico}`;
        
        const dados = {
            nmrelatorio: opcaoSelecionada.value,
            idmunicipio: globalStore.idmunicipio,
            idequipamento: idEquipamento.value,
            idequipamentogrupo: idGrupo.value,
            idlocalidade: idLocalidade.value,
            idregiao: idRegiao.value,
            idservico: Funcoes.getId(objServico.value),
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate,
            informacoes,
            idusuario: globalStore.idusuario};
        const response = await genericReport(dados);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
}
</script>